<template>
  <div>
      <input name="somename" type="text" style="width:100px;height:20px;">
  </div>
</template>
<script>
export default {
    name: 'rm-input',
    props: { },
    data: function () {
        return { }
    },
    created () { },
    mounted () { },
    methods: { }
}
</script>



// WEBPACK FOOTER //
// src/components/rm-input.vue